import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EASE_REFINED } from './constants';
import CategoryTag from './CategoryTag';
import FadeIn from './FadeIn';

export default function BlogCard({ post, delay = 0 }) {
  return (
    <FadeIn delay={delay}>
      <Link to={`/blog/${post.slug}`} className="blog-card-link">
        <motion.article
          className="luxury-card blog-card"
          whileHover={{ y: -4 }}
          transition={{ duration: 0.35, ease: EASE_REFINED }}
        >
          <CategoryTag label={post.category} />
          <h3 className="blog-card__title">{post.title}</h3>
          <p className="blog-card__excerpt">{post.excerpt}</p>
          <div className="blog-card__footer">
            <div>
              <div className="blog-card__author">{post.author}</div>
              <div className="blog-card__read-time">{post.readTime}</div>
            </div>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path
                d="M2 7h10M8 4l3 3-3 3"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </motion.article>
      </Link>
    </FadeIn>
  );
}
